const buttons = document.querySelectorAll('.Button:not(.Button--no-style), .kb-adv-form-submit-button');

buttons.forEach(btn => {
  btn.addEventListener('mouseenter', () => {
    btn.classList.add('is-hover'); // trigger fade-in
  });

  btn.addEventListener('mousemove', e => {
    const rect = btn.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    // update only position vars — transform will update instantly (no transition)
    btn.style.setProperty('--x', `${x}px`);
    btn.style.setProperty('--y', `${y}px`);
  });

  btn.addEventListener('mouseleave', () => {
    btn.classList.remove('is-hover'); // fade-out
  });
});
